<template>
  <CBreadcrumb class="d-md-down-none me-auto mb-0">
    <li v-for="item in breadcrumbs" :key="item" class="breadcrumb-item" :class="item.active ? 'active' : ''">
      <router-link :to="item.path" v-if="!item.active">{{ item.name }}</router-link>
      <span v-else>{{ item.name }}</span>
    </li>
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import router from '@/router'

export default {
  name: 'AppBreadcrumb',
  setup() {
    const breadcrumbs = ref()
    const getBreadcrumbs = () => {
      return router.currentRoute.value.matched.map((route) => {
        return {
          active:
            (route.path.includes(':id')
              ? route.path.replace(
                  ':id',
                  router.currentRoute.value.params?.id.toString(),
                )
              : route.path) === router.currentRoute.value.fullPath,
          name: route.name,
          path: `${router.options.history.base}${route.path}`,
        }
      })
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
}
</script>
